/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {colors} from "nxtconstants";

import {
  wrapper,
  title,
  button,
  infoline
} from "../styledElements";
import {WealthyEnv} from "helpers";

const propTypes = {
  linkKyc: PropTypes.func
};

const LinkToKyc = ({
  linkKyc
}) => {
  return (
    <UserCredentialsWrapper>
      <TickIcon src={`${WealthyEnv.BROKING_CDN_URL}/ruby-tick-icon.png`} />
      <Title>Congratulations!</Title>
      <InfoLine>
        You have been registered successfully
      </InfoLine>
      <SubmitCredentials onClick={linkKyc} >
        Start your KYC
      </SubmitCredentials>
      <UserMsg>
      *Complete your KYC in minutes and start your wealth journey.
      </UserMsg>
    </UserCredentialsWrapper>
  );
};

const UserCredentialsWrapper = styled(wrapper)``;

const TickIcon = styled.img`
  width: 16rem;
  display: block;
  margin: 0 auto;
`;

const Title = styled(title)``;

const InfoLine = styled(infoline)``;

const SubmitCredentials = styled(button)`
  width: 100%;
  margin: 3.4rem 0 0.8rem;

  @media (max-width: 576px) {
    margin: 2rem 0;
  }
`;

const UserMsg = styled.p`
  color: ${colors.textGray};
  font-size: 1.2rem;
  max-width: 26rem;
  text-align: center;
`;

LinkToKyc.propTypes = propTypes;

export default LinkToKyc;
